var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77209 0.349808C5.81153 0.388228 5.98017 0.533297 6.11889 0.668429C6.99133 1.46068 8.41933 3.52741 8.85521 4.60913C8.92525 4.77341 9.07349 5.18875 9.08301 5.41065C9.08301 5.62329 9.03405 5.82599 8.93477 6.01941C8.79605 6.26053 8.57777 6.45396 8.32005 6.55994C8.14121 6.62817 7.60605 6.73416 7.59653 6.73416C7.01105 6.84014 6.05973 6.89844 5.00845 6.89844C4.00681 6.89844 3.09425 6.84014 2.49993 6.75337C2.49041 6.74343 1.82537 6.63745 1.59757 6.52152C1.18141 6.30889 0.923008 5.89355 0.923008 5.44907L0.923008 5.41065C0.933208 5.12118 1.19161 4.51242 1.20113 4.51242C1.63769 3.48899 2.99565 1.46995 3.89801 0.658494C3.89801 0.658494 4.12989 0.42996 4.27473 0.330598C4.48281 0.175593 4.74053 0.0987531 4.99825 0.0987531C5.28589 0.0987531 5.55381 0.185529 5.77209 0.349808Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown2);
export default __webpack_public_path__ + "static/media/Arrow---Down-2.38ae09082b22f1b0d1288f0c171fe904.svg";
export { ForwardRef as ReactComponent };